import { MainLayoutQuery } from "@/lib/sanity/queries";
import dynamic from "next/dynamic";
import { Container } from "./styles";

// Cast to fix React 17 + @types/react 18 compatibility issue
const MenuTab = dynamic(() => import("./MenuTab")) as any;
const InternalLink = dynamic(() => import("./InternalLink")) as any;
const ExternalLink = dynamic(() => import("./ExternalLink")) as any;

type Props = {
  items: MainLayoutQuery["header"]["navigation"]["items"];
};

const DesktopNav: React.FC<Props> = (props) => {
  const { items } = props;

  if (!items?.length) return null;

  return (
    <Container>
      {items?.map((item) => {
        if (!item?._key) return null;
        switch (item?._type) {
          case "headerTab":
            return <MenuTab key={item._key} tab={item} />;
          case "internalLink":
            return <InternalLink key={item._key} {...item} />;
          case "externalLink":
            return <ExternalLink key={item._key} {...item} />;
          default:
            return null;
        }
      })}
    </Container>
  );
};

export default DesktopNav;
